import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const appearanceConfiguration = () => axiosInstance.get('/appearance/configuration', { params: pickDevParams });
